import { useState, useEffect } from 'react';

import data from 'data/sources.json';

import { News } from 'types/prize';

/**
 * 「お知らせ」のデータを返します。
 * @param {number} [outputCount] - 出力するニュースの数を制限します。このパラメータが指定されていない場合、全てのニュースを出力します。
 * @return {News[] | null} - 指定された数のニュース、または全てのニュースを返します。ニュースデータが存在しない場合はnullを返します。
 * @example
 * // 全てのニュースを取得
 * const news = useNews();
 * @example
 * // 最初の3件のニュースを取得
 * const news = useNews(3);
 */
export const useNews = (outputCount?: number) => {
  const [news, setNews] = useState<News[] | null>(null);
  const [displayNews, setDisplayNews] = useState<News[] | null>(null);

  useEffect(() => {
    setNews(data.news);
  }, []);

  useEffect(() => {
    if (news && outputCount !== undefined) {
      setDisplayNews(news.slice(0, outputCount));
    } else {
      setDisplayNews(news);
    }
  }, [news, outputCount]);

  return displayNews;
};
